import React from "react"
import { 
  Button, 
  OverlayTrigger,
  Tooltip,
  Spinner
} from "react-bootstrap"
import {
  HiTrash
} from 'react-icons/hi'
import {
  ButtonCreateInterface
} from '../ButtonCreate'

export const ButtonDelete: React.FC<ButtonCreateInterface> = ({
  variant,
  text,
  icon = false,
  tooltip = true,
  tooltipText,
  tooltipPlacement,
  style,
  size = 'sm',
  loading,
  loadingText,
  disabled,
  noText = false,
  ...rest
}) => {
  const checkIsVariantOutline = (variant: String) => Boolean(variant.substring(0,7) === 'outline')

  return (
    <OverlayTrigger
      placement={tooltipPlacement}
      overlay={tooltip ? <Tooltip>{tooltipText ?? 'Hapus data'}</Tooltip> : <div></div>}
    >
      <Button
        {...rest}
        size={size === "sm" ? "sm" : size === "lg" ? "lg" : undefined}
        variant={variant ?? "danger"}
        disabled={loading ? true : disabled ? true : false}
        style={{
          ...style,
          minWidth: icon ? 'auto' : '100px' 
        }}
      >
        {loading ? (
          <div className="d-flex justify-content-center align-items-center">
            <div className="d-flex align-items-center">
              <Spinner 
                animation="border" 
                variant={checkIsVariantOutline(variant ?? 'primary') ? variant : 'white'}
                size="sm" 
              />
              {Boolean(text) &&
                <div className={`ms-2 ml-2 ${variant === 'warning' || variant === "info" ? 'text-white' : ''}`}>
                  {loadingText ?? "Memproses . . ."}
                </div>
              }
            </div>
          </div>
        ) : (
          <div className="d-flex justify-content-center align-items-center text-white">
            <div>
              {icon && <HiTrash className="mb-1"/>}
            </div>
            {!noText && (
              <span className="mx-1 text-uppercase">
                {text  ? text : 'Hapus'}
              </span>
            )}
          </div>
        )}
      </Button>
    </OverlayTrigger>
  )
}